import { useCallback, useState } from 'react'

interface RunUndoableActionArgs {
  id: string
  onStart?: () => void
  onAction: (args: { onError: () => void; onUndo: () => void }) => void
  onError?: () => void
  onUndo?: () => void
}

export const useUndoableAction = () => {
  const [hiddenIds, setHiddenIds] = useState<string[]>([])

  const hide = useCallback((id: string) => {
    setHiddenIds((ids) => (ids.includes(id) ? ids : [...ids, id]))
  }, [])

  const restore = useCallback((id: string) => {
    setHiddenIds((ids) => ids.filter((hiddenId) => hiddenId !== id))
  }, [])

  const isHidden = useCallback(
    (id?: string) => Boolean(id && hiddenIds.includes(id)),
    [hiddenIds],
  )

  const run = useCallback(
    ({ id, onAction, onError, onStart, onUndo }: RunUndoableActionArgs) => {
      hide(id)
      onStart?.()
      onAction({
        onError: () => {
          restore(id)
          onError?.()
        },
        onUndo: () => {
          restore(id)
          onUndo?.()
        },
      })
    },
    [hide, restore],
  )

  return { hiddenIds, hide, isHidden, restore, run }
}
